export const auth = {
  activationPage: {
    loading: 'Activation du compte…',
  },
  footer: {
    social: {
      facebook: {
        ariaLabel: 'Facebook',
        link: 'https://www.facebook.com/creativeshelter/',
      },
      instagram: {
        ariaLabel: 'Instagram',
        link: 'https://www.instagram.com/creativeshelter/',
      },
      linkedIn: {
        ariaLabel: 'LinkedIn',
        link: 'https://be.linkedin.com/company/creative-shelter/',
      },
      website: {
        ariaLabel: 'Site web de Creative Shelter',
        link: 'https://www.creativeshelter.be/',
      },
    },
    trademark: 'Creative Shelter © {{year}}',
  },
  forgotPasswordPage: {
    form: {
      submitButton: 'Envoyer le lien',
    },
    header: {
      subtitle: 'Saisissez votre adresse e-mail et nous vous enverrons les étapes pour définir un nouveau mot de passe.',
      title: 'Réinitialiser le mot de passe',
    },
    loginCta: {
      link: 'Se connecter',
      text: 'Vous vous souvenez de votre mot de passe ?',
    },
    successAlert: {
      description:
        'Les étapes pour définir votre nouveau mot de passe sont dans votre boîte mail. Rien reçu ? Vérifiez votre adresse e-mail.',
      title: 'Les étapes sont dans votre boîte mail !',
    },
    tokenExpiredAlert: {
      description: 'Demandez ici un nouveau lien pour modifier votre mot de passe.',
      title: 'Lien expiré',
    },
  },
  loginPage: {
    accountantLoginCta: {
      action: '<accountantLink href="https://api.creativeshelter.be/accountants/login">Connectez-vous ici</accountantLink>',
      message: 'Vous êtes comptable ?',
    },
    errors: {
      ineligible: {
        description:
          'Vous ne pouvez pas encore vous connecter, car vous n’êtes pas automatiquement éligible. Nous vérifions votre profil et vos activités, vous aurez bientôt de nos nouvelles !',
        title: 'En attente d’approbation',
      },
      invalidEmailOrPassword: 'Votre adresse e-mail ou votre mot de passe est incorrect.',
      rejected: {
        description:
          'Nous avons vérifié votre profil et vous n’êtes pas éligible à la facturation via Creative Shelter. Votre compte a donc malheureusement été désactivé.',
        title: 'Désolés, vous n’êtes pas éligible',
      },
      unverifiedEmail: {
        description: 'Votre adresse e-mail n’a pas encore été vérifiée. Consultez votre boîte mail et confirmez votre adresse e-mail.',
        title: 'En attente de vérification',
      },
    },
    forgotPasswordLink: 'Mot de passe oublié ?',
    form: {
      emailField: {
        label: 'Adresse e-mail',
      },
      passwordField: {
        label: 'Mot de passe',
      },
      submitButton: 'Se connecter',
    },
    header: {
      eyebrow: 'Connexion',
      subtitle: 'Connectez-vous pour accéder à la plateforme.',
      title: 'Bon retour parmi nous !',
    },
    registerCta: {
      action: 'Créer un compte',
      message: 'Vous n’avez pas encore de compte ?',
    },
    sessionExpiredAlert: {
      description: 'Reconnectez-vous pour continuer.',
      title: 'Session expirée',
    },
  },
  logo: 'Site web de Creative Shelter',
  passwordResetErrors: {
    ineligible: {
      description:
        'Votre profil n’a pas encore été approuvé, vous ne pouvez donc pas encore choisir de nouveau mot de passe. Nous vous tiendrons au courant dès que votre profil aura été vérifié.',
      title: 'En attente d’approbation',
    },
    rejected: {
      description:
        'Nous avons vérifié votre profil, mais vous n’êtes pas éligible à la facturation via Creative Shelter. Votre compte a donc été désactivé.',
      title: 'Désolés, vous n’êtes pas éligible',
    },
    unverifiedEmail: {
      description:
        'Vous ne pouvez pas demander de nouveau mot de passe tant que votre adresse e-mail n’est pas vérifiée. Consultez votre boîte mail et vérifiez votre adresse e-mail.',
      title: 'En attente de vérification',
    },
  },
  registrationPage: {
    common: {
      header: {
        pill: 'Inscription',
      },
      loginCta: {
        action: 'Se connecter',
        message: 'Vous avez déjà un compte ?',
      },
      previousStepButton: 'Précédent',
      referralCode: {
        addButton: 'Code de réduction',
        applied: 'Réduction !',
        form: {
          invitationsField: {
            description:
              'Nous constatons que plusieurs freelances vous ont invité·e. Choisissez l’invitation que vous souhaitez accepter ou saisissez vous-même un (autre) code de réduction.',
            invitedAt: 'Invitation du {{date}}',
          },
          referralCodeField: {
            errors: {
              expired: 'Ce code de réduction a expiré.',
              generic: 'Le code de réduction ne peut pas être validé pour le moment.',
              invalid: 'Ce code de réduction n’est pas valide.',
            },
            invitationDescription: 'Vous avez été invité·e par {{name}} avec le code de réduction <code>{{code}}</code>.',
            label: 'Code de réduction',
          },
          submitButton: 'Appliquer',
        },
        types: {
          fromAccountant: 'Le code de réduction {{referralCode}} du comptable {{name}} a été appliqué !',
          fromAdmin: {
            generic: 'Le code de réduction {{referralCode}} a été appliqué !',
          },
          fromUser:
            'Une réduction grâce au code {{referralCode}} de {{name}} ! Créez votre première facture et profitez tous les deux d’une réduction !',
        },
      },
    },
    stepAccountInformation: {
      alertNoElibibleNacebelCodes: {
        description:
          'Vous pouvez poursuivre votre inscription, mais nous activerons votre compte après une vérification manuelle de vos activités.',
        title: 'Vous n’êtes pas éligible d’office',
      },
      form: {
        callingCodeField: {
          label: 'Indicatif',
          options: {
            other: 'Autre',
          },
        },
        emailField: {
          errors: {
            exists: 'Cette adresse e-mail est déjà utilisée. Connectez-vous ou réinitialisez votre mot de passe.',
            generic:
              'Une erreur s’est produite lors de la validation de votre adresse e-mail. Contactez <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> si le problème persiste.',
          },
          label: 'Adresse e-mail',
        },
        passwordField: {
          label: 'Mot de passe',
          requirements: {
            error: 'Le mot de passe ne répond pas aux exigences.',
            minLength: 'Au moins 8 caractères',
            mixedCasing: 'Au moins 1 majuscule et 1 minuscule',
            nonAlpha: 'Au moins 1 chiffre ou caractère spécial',
          },
        },
        phoneNumberField: {
          label: 'Numéro de téléphone',
        },
        submitButton: 'Suivant',
      },
      header: {
        subtitle: 'Prêt·e à vous lancer ?',
        title: 'Bonjour {{name}}',
      },
    },
    stepBusinessInformation: {
      errors: {
        fallback: 'Une erreur inattendue s’est produite lors de votre inscription.',
        httpError:
          'Une erreur s’est produite lors de votre inscription. Contactez <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> si le problème persiste.',
      },
      form: {
        mainOccupationField: {
          label: 'Statut',
          options: {
            mainOccupation: 'Activité principale',
            secondaryOccupation: 'Activité complémentaire',
          },
        },
        otherActivitiesField: {
          label: 'Décrivez vos autres activités créatives',
        },
        primaryActivityField: {
          label: 'Activité principale',
        },
        secondaryActivityField: {
          label: 'Avez-vous d’autres activités créatives ?',
        },
        submitButton: 'Créer un compte',
      },
      header: {
        subtitle: 'Parlez-nous de votre entreprise individuelle.',
        title: 'Bonjour {{name}}',
      },
    },
    stepCompany: {
      alert: {
        description:
          'Notre plateforme est conçue pour les entreprises individuelles. Heureusement, Creative Shelter propose aussi une solution pour les sociétés. <break/>Intéressé·e ? <kiiaLink href="https://www.creativeshelter.be/kom-ik-in-aanmerking">Vérifiez si vous êtes éligible</kiiaLink> et nous reviendrons rapidement vers vous.',
        title: 'Creative Shelter pour les sociétés',
      },
      changeVatNumber: {
        action: 'Modifier',
        message: 'Ce n’est pas le bon numéro de TVA ?',
      },
      header: {
        subtitle: 'Nous constatons que vous avez une société.',
        title: 'Bonjour, gérant·e de {{name}}',
      },
    },
    stepSuccess: {
      header: {
        subtitle: {
          eligible: 'Vous avez franchi la ligne d’arrivée, consultez votre boîte mail',
          ineligible: 'Données bien reçues !',
        },
        title: 'Votre compte a été créé',
      },
      linkAccountant: {
        errors: {
          generic: 'Une erreur s’est produite lors de l’association de votre comptable.',
        },
        form: {
          accountantEmailAddressField: {
            description:
              'Vous pouvez saisir ici l’adresse e-mail de votre comptable. S’il ou elle ne connaît pas encore Creative Shelter, nous nous présenterons brièvement.',
            label: 'Travaillez-vous avec un comptable ?',
          },
        },
        success: {
          message: 'Merci de nous avoir transmis les coordonnées de votre comptable. Nous nous en occupons.',
          title: 'Bien reçu !',
        },
      },
      message: {
        eligible: 'Un e-mail a été envoyé à <bold>{{email}}</bold>. Confirmez votre adresse e-mail via le lien pour activer votre compte.',
        ineligible:
          'Nous vérifions si vous êtes éligible à la facturation via Creative Shelter.<break/>Vous pouvez fermer cette fenêtre, nous vous tiendrons au courant par e-mail dès que possible.',
      },
    },
    stepVatNumber: {
      alert: {
        kboNotAvailable: {
          description:
            'En raison d’une panne à la BCE, nous ne pouvons pas vérifier votre numéro de TVA pour le moment. Veuillez réessayer plus tard.',
          title: 'La BCE est momentanément inaccessible',
        },
      },
      form: {
        submitButton: 'C’est parti',
        vatNumberField: {
          description:
            'Vous n’avez pas encore de numéro de TVA ? <faqLink href="https://www.creativeshelter.be/knowledge-hub/kan-ik-mij-al-aansluiten-bij-creative-shelter-als-mijn-btw-nummer-nog-in-aanvraag-is">Lisez ici</faqLink> ce que vous devez faire.',
          errors: {
            exists: 'Un compte existe déjà avec ce numéro de TVA. Pouvez-vous vérifier ?',
            fallback: 'Une erreur inattendue s’est produite lors de la validation de votre numéro de TVA.',
            httpError:
              'Une erreur s’est produite lors de la validation de votre numéro de TVA. Contactez <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> si le problème persiste.',
            inactiveVatNumber:
              'Votre numéro de TVA n’est pas encore actif selon la BCE. L’inscription n’est possible qu’avec un numéro de TVA actif. Veuillez réessayer plus tard.',
            invalidVatNumber: 'Le numéro de TVA indiqué n’existe pas dans la BCE. Pouvez-vous vérifier ?',
            vatNumberChecksum: 'Le numéro de TVA ne semble pas correct. Pouvez-vous vérifier s’il contient une erreur ?',
            vatNumberLength: 'Un numéro de TVA se compose de 10 chiffres, dont le premier est 0 ou 1.',
          },
          label: 'Numéro de TVA',
        },
      },
      header: {
        subtitle: 'Créez gratuitement votre compte Creative Shelter',
        title: 'Tirez le meilleur parti de vos droits d’auteur',
      },
    },
  },
  resendVerificationEmail: {
    error:
      'Une erreur s’est produite lors de l’envoi de l’e-mail de vérification. Contactez service@creativeshelter.be si le problème persiste.',
    send: 'Rien reçu ? <button>Cliquez ici</button> pour renvoyer l’e-mail.',
    sent: 'Nous avons envoyé un nouvel e-mail de vérification à <bold>{{emailAddress}}</bold>. Toujours rien reçu ? Réessayez dans {{seconds}} secondes.',
  },
  resetPasswordPage: {
    form: {
      submitButton: 'Définir le nouveau mot de passe',
    },
    header: {
      subtitle: 'Choisissez un nouveau mot de passe pour votre compte.',
      title: 'Définir un nouveau mot de passe',
    },
  },
  sidebars: {
    checklist: {
      features: {
        first: 'Gardez plus en net grâce à vos droits d’auteur.',
        second: 'Facturez en toute simplicité via notre plateforme.',
        third: 'Bénéficiez de l’aide de vraies personnes et d’une communauté de freelances.',
        title: 'La seule plateforme de facturation qui gère les droits d’auteur.',
      },
    },
    kiia: {
      eligibilityTest: {
        button: 'Faire le test',
        description: 'Découvrez en quelques questions simples si vous êtes éligible à une rémunération en droits d’auteur.',
        title: 'Pouvez-vous facturer des droits d’auteur ?',
      },
    },
  },
};
